module.exports = __webpack_public_path__ + "img/微信图片_20200925103004.9ee6716f.png";